export const CREDIT_AUTOMATION_SLICE_NAME = "creditAutomation"
